export const USER_ACTIONS = {
  attachToPartner: "attach-to-partner",
  detachFromPartner: "detach-from-partner",
  attachToProject: "attach-to-project",
  detachFromProject: "detach-from-project",
};
